import ToastUtils from '../utils/toast';

/**
 * Форматирует сообщение об ошибке в читаемом виде
 * @param {string|object} error - Сообщение об ошибке (строка или объект с полями error/message)
 * @returns {string} - Отформатированное сообщение
 */
const formatErrorMessage = (error) => {
  if (!error) {
    return 'Произошла неизвестная ошибка';
  }

  // Если error - объект, извлекаем сообщение
  if (typeof error === 'object') {
    return error.error || error.message || JSON.stringify(error);
  }

  // Если error - строка, возвращаем как есть
  return error;
};

/**
 * Обрабатывает ошибки API и отправляет их в ToastUtils
 * @param {string|object} error - Сообщение об ошибке
 * @param {object} options - Дополнительные опции для ToastUtils
 */
export const handleApiError = (error, options = {}) => {
  const errorMessage = formatErrorMessage(error);
  ToastUtils.error(errorMessage, options);
  return errorMessage;
};

/**
 * Обрабатывает HTTP ошибки API
 * @param {number} status - HTTP статус код
 * @param {string|object} errorData - Данные ошибки от сервера
 * @param {object} options - Дополнительные опции для ToastUtils
 */
export const handleHttpError = (status, errorData = null, options = {}) => {
  let errorMessage;

  if (errorData) {
    errorMessage = formatErrorMessage(errorData);
  } else {
    errorMessage = `HTTP ошибка! Статус: ${status}`;
  }

  ToastUtils.error(errorMessage, options);
  return errorMessage;
};

/**
 * Обрабатывает сетевые ошибки
 * @param {Error} error - Объект ошибки
 * @param {object} options - Дополнительные опции для ToastUtils
 */
export const handleNetworkError = (error, options = {}) => {
  const errorMessage = error?.message || 'Ошибка соединения. Пожалуйста, проверьте интернет-соединение';
  ToastUtils.error(errorMessage, options);
  return errorMessage;
};
